import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import BankConfigurationComponent from '../components/bank-configuration.component';
import { bankConfigurations } from '../../../../../../redux/bank-configurations/action';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectBankConfigurationsQueryItems } from '../../../../../../redux/bank-configurations/selector';
import { selectAccountLedgersListItems } from '../../../../../../redux/account-ledgers/selector';

const ManagementBankConfiguration = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const bankConfigurationsQueryData = useSelector(selectBankConfigurationsQueryItems)
  const accountledgersItems = useSelector(selectAccountLedgersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectBankConfigurations, setSelectBankConfigurations] = useState<any>([])

  const fetchBankConfigurationsQueryById = () => {
    dispatch(bankConfigurations.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations/query`,
      entity: 'bankConfigurations',
      jsonData: {
        Records: [
          {
            LedgerId: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectBankConfigurations({ ...selectBankConfigurations, [field]: event })
  }

  useEffect(() => {
    dispatch(accountLedgers.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
      entity: 'accountLedgers',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchBankConfigurationsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectBankConfigurations(bankConfigurationsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(bankConfigurations.resetAction({ actionType: 'update' }))
      await dispatch(bankConfigurations.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations`,
        entity: 'bankConfigurations',
        jsonData: {
          Records: [
            selectBankConfigurations
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(bankConfigurations.resetAction({ actionType: 'create' }))
      await dispatch(bankConfigurations.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations`,
        entity: 'bankConfigurations',
        jsonData: {
          Records: [
            selectBankConfigurations
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/accounts/bank-configurations')
  }

  return (
    <>
      {bankConfigurationsQueryData?.isLoading ? <PageLoader /> :
        <BankConfigurationComponent
          handleInnerFormChange={handleInnerFormChange}
          selectBankConfigurations={selectBankConfigurations}
          ledgersList={accountledgersItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
}

export default ManagementBankConfiguration;